export default __webpack_public_path__ + "static/media/HospitalatHome-WHSCTv3.4rLbh1_HAXkcuZqF9fjnkFfC0HPNrR7orsTlq8MHzwPY.4067fd76.jpeg";